import { render, staticRenderFns } from "./SelectPerson.vue?vue&type=template&id=683e4bad&scoped=true&"
import script from "./SelectPerson.vue?vue&type=script&lang=js&"
export * from "./SelectPerson.vue?vue&type=script&lang=js&"
import style0 from "./SelectPerson.vue?vue&type=style&index=0&id=683e4bad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683e4bad",
  null
  
)

export default component.exports